module.exports = __webpack_public_path__ + "portal/assets/img/logo.53d42836.svg";